import { Component, computed, input } from '@angular/core';

const SIZE_MAP = {
  SMALL: '50px',
  NORMAL: '120px',
} as const;

@Component({
  selector: 'rid-dice-face',
  imports: [],
  templateUrl: './rid-dice-face.html',
  styleUrl: './rid-dice-face.css',
  host: {
    '[style.--dice-size]': 'cssSize()',
    '[style.--dice-color]': 'cssColor()',
  },
})
export class RidDiceFace {
  /** Size of the dice face */
  size = input<'SMALL' | 'NORMAL'>('NORMAL');
  /** Color of the dice face (Tailwind color name, e.g. 'blue-500', 'red-400') */
  color = input<string | undefined>(undefined);

  protected cssSize = computed(() => SIZE_MAP[this.size()]);
  protected cssColor = computed(() => {
    const c = this.color();
    return c ? `var(--color-${c})` : undefined;
  });
}
